export interface Urls {
  /** Standard HTTP for REST and GraphQL */
  api: string;
  /** Web Sockets */
  ws: string;
  /** Application context path */
  basePath: string;
  /** External OpenAPI documentation */
  xapi: string;
}

const apiPort = import.meta.env.MIDDLE_TIER_PORT ? Number.parseInt(import.meta.env.MIDDLE_TIER_PORT, 10) : 9000;
const serverUsesLocalhost = import.meta.env.DEV_USES_LOCALHOST
  ? Number.parseInt(import.meta.env.DEV_USES_LOCALHOST, 10) > 0
  : true;

// Calculate context path once (dev should stay at root)
const applicationPath = import.meta.env.DEV
  ? "/"
  : location.pathname === "/"
    ? "/"
    : `/${location.pathname.split("/")[1]}/`;
const sameOriginBase = `${location.origin}${applicationPath}`;
const sameOriginWsBase = `${location.protocol === "https:" ? "wss:" : "ws:"}//${location.host}${applicationPath}`;

// Localhost configuration
const localDevEnvironment: Urls = {
  api: `${sameOriginBase}api`,
  ws: `${sameOriginWsBase}ws`,
  basePath: "/",
  xapi: `${sameOriginBase}xapi/docs/`,
};

// Host interface configuration
const networkDevEnvironment: Urls = {
  api: `${location.protocol}//${location.hostname}:${apiPort}/api`,
  ws: `${location.protocol === "https:" ? "wss:" : "ws:"}//${location.hostname}:${apiPort}/ws`,
  basePath: "/",
  xapi: `${location.protocol}//${location.hostname}:${apiPort}/xapi/docs/`,
};

// Production configuration
const productionEnvironment: Urls = {
  api: `${location.protocol}//${location.host}${applicationPath}api`,
  ws: `${location.protocol === "https:" ? "wss:" : "ws:"}//${location.host}${applicationPath}ws`,
  basePath: applicationPath,
  xapi: `${location.protocol}//${location.host}${applicationPath}xapi/docs/`,
};

export const urls: Urls = import.meta.env.PROD
  ? productionEnvironment
  : serverUsesLocalhost
    ? localDevEnvironment
    : networkDevEnvironment;
